import { rem } from 'polished'
import styled from 'styled-components'
import { AccommodationRoomTileImageContainer } from '../AccommodationRoomTileImage'
import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { isHotelPackage } from 'lib/offer/offerTypes'
import { StyledAccommodationSameRoomTileDetails } from './AccommodationSameRoomTileDetails'
import { AccommodationSameRoomTileGridBase } from './AccommodationSameRoomTileGridBase'

const AccommodationSameRoomTileGrid = styled(AccommodationSameRoomTileGridBase)`
  position: relative;

  &.hasImage {
    display: grid;
    grid-template:
      "image" ${rem(210)}
      "details" auto / 1fr;
  }

  &:not(.hasImage) {
    display: grid;
    grid-template: "details" auto / 1fr;

    > ${AccommodationRoomTileImageContainer} {
      display: none;
    }
  }

  > ${AccommodationRoomTileImageContainer} {
    grid-area: image;
  }
  > ${StyledAccommodationSameRoomTileDetails} {
    grid-area: details;
  }
`
interface Props extends PropsWithChildren {
  roomPackage: App.HotelPackage | App.BedbankPackage
  imageSize?: 'small' | 'medium'
}

function AccommodationSameRoomTile(props: Props) {
  const { roomPackage, imageSize = 'medium', children } = props
  const room = roomPackage ? (isHotelPackage(roomPackage) ? roomPackage.roomType : roomPackage) : null

  return <AccommodationSameRoomTileGrid
    background="neutral-eight"
    className={clsx({ hasImage: !!room?.images?.length }, `image-size-${imageSize}`)}
  >
    {children}
  </AccommodationSameRoomTileGrid>
}

export default AccommodationSameRoomTile
